import { store } from '../../store/index.js';
import { isCP } from '../../utils/app-utils.js';

export default class PermissionsHelper {
  static getPermissions(permissionKey, action) {
    let permissionsData = !!isCP()
    ? store?.getState()?.cpUserData?.userInfo?.permission_map
    : !!store?.getState()?.userData?.userInfo?.userProfile?.permission_map
    ? store?.getState()?.userData?.userInfo?.userProfile?.permission_map
    : {};
    if (!!permissionsData) {
      if (!!permissionsData['all']) {
        return true;
      } else {
        if (!!permissionsData[permissionKey]) {
          if (!!permissionsData[permissionKey]['manage']) {
            return true;
          } else {
            if (!!permissionsData[permissionKey][action]) {
              return true;
            } else {
              return false;
            }
          }
        } else {
          return false;
        }
      }
    }
  }
}
